export const getIconStyle = (color: string) => ({
    bgcolor: color,
    color: 'white',
    fontSize: 20,
    padding: 0.3,
    borderRadius: 2
});

export const ICON_COLORS = {
    ORANGE: 'orange',
    GREEN: '#65C466',
    RED: 'red',
    BLUE: '#59A8D6',
    YELLOW: '#FECE00',
    GRAY: '#8E8E93',
    DARK_RED: '#EB4E3D'
} as const;
